module.exports = __webpack_public_path__ + "static/cabina-conductor---mampara-divisoria-7a384f9c85bacd69b752756e1cd92d54.jpg";